/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway-group.scss';

/* eslint-disable import/no-unresolved, import/default */

import gatewayGroupFieldsetTemplate from './gateway-group-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function GatewayGroupDirective($compile, $templateCache, $translate, $mdUtil, $filter, types, gatewayService, gatewayGroupService, importExport, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(gatewayGroupFieldsetTemplate);
        element.html(template);
        scope.types = types;

        scope.onGatewayGroupIdCopied = function() {
            toast.showSuccess($translate.instant('gateway-group.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        scope.$watch('isEdit', (newVal, prevVal) => {
            if (newVal && !angular.equals(newVal, prevVal)) {
                scope.selectedTab = 0;
            }
        });

        scope.onGatewayGroupTabSelected = function(eventName) {
            scope.$broadcast(types.broadcastEvents.GATEWAY_GROUP[eventName]);
        }

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            gatewayGroup: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/gateway-group/gateway-group.directive.js